import { FC, ReactNode } from 'react'
import { Box } from '@mui/material'
import { colors } from '../../const/colors'

export const SectionActions: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '10px',
      mt: '14px',
    }}
  >
    {children}
  </Box>
)

const TONES = {
  primary: {
    background: colors.navy,
    color: '#fff',
    boxShadow: colors.shadowBtn,
    '&:hover': { background: colors.navyDark },
  },
  danger: {
    background: colors.surface,
    border: `1.5px solid ${colors.redBorder}`,
    color: colors.red,
    '&:hover': { background: colors.redBg },
  },
  neutral: {
    background: colors.surface,
    border: `1.5px solid ${colors.border3}`,
    color: colors.textSecondary,
    '&:hover': { borderColor: colors.navy, color: colors.navy },
  },
} as const

const BUTTON_WIDTH = 170

export const SectionButton: FC<{
  label: string
  icon?: ReactNode
  tone?: keyof typeof TONES
  disabled?: boolean
  height?: number
  width?: number | 'auto'
  e2e?: string
  onClick: () => void
}> = ({
  label,
  icon,
  tone = 'primary',
  disabled,
  height = 44,
  width = BUTTON_WIDTH,
  e2e,
  onClick,
}) => (
  <Box
    onClick={() => !disabled && onClick()}
    data-e2e={e2e}
    aria-disabled={!!disabled}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      flexShrink: 0,
      height,
      width,
      maxWidth: '100%',
      px: '14px',
      borderRadius: colors.radiusBtn,
      fontSize: '13.5px',
      fontWeight: 700,
      transition: 'background .15s, color .15s, border-color .15s',
      ...(disabled
        ? {
            background: colors.bg,
            color: colors.slateLight,
            cursor: 'not-allowed',
          }
        : { cursor: 'pointer', ...TONES[tone] }),
    }}
  >
    {icon}
    {label}
  </Box>
)
